export default "__VITE_ASSET__DY39Jc63__"